// extracted by mini-css-extract-plugin
export default {"container":"UN-z","dimension":"VN-z","dimensionLabels":"WN-z"};